import axios from 'axios';
import { getConfig } from '../../../config';
import { clearAgentDashboardTokens, getAuthorizationToken, getIdentityAssertion } from './token';

export * from './token';

export const claudeCodeInstance = axios.create({
  baseURL: getConfig().internalApiUrl,
  timeout: 15000,
});

claudeCodeInstance.interceptors.request.use(async (requestConfig) => {
  const token = await getAuthorizationToken();
  if (token) {
    requestConfig.headers.set('Authorization', `Bearer ${token}`);
  }
  const assertion = await getIdentityAssertion();
  if (assertion) {
    requestConfig.headers.set('x-identity-assertion', assertion);
  }
  return requestConfig;
});

claudeCodeInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      // Token rejected — clear so the page falls back to Google login.
      clearAgentDashboardTokens();
    }
    return Promise.reject(error);
  },
);
